import { BaseEntityService } from "./base-entity.service";
import { Injectable } from "@angular/core";

import { AngularFirestore } from "@angular/fire/firestore";
import { TravelAdvisorProfile } from "./travel-advisor-profile.model";

export class TravelAdvisorProfileService extends BaseEntityService<
  TravelAdvisorProfile
  > {
  constructor(db: AngularFirestore, userId: string) {
    super(db, TravelAdvisorProfile, "users/" + userId + "/", "profiles");
  }
}

@Injectable({
  providedIn: "root"
})
export class TravelAdvisorProfileServiceFactory {
  constructor(private db: AngularFirestore) {

  }

  create(userId: string): TravelAdvisorProfileService {
    return new TravelAdvisorProfileService(this.db, userId);
  }
}


